import type { ReactElement } from 'react';

import { Card, type IWithPopoverProps, WithPopover } from '@procurify/ui'

import {
  type IOrderItemTooltipProps,
  OrderItemTooltip,
} from './OrderItemTooltip'

export interface IWithOrderItemTooltipProps extends IOrderItemTooltipProps {
  disabled?: boolean
  WithPopoverProps?: Partial<Omit<IWithPopoverProps, 'ref'>>
  /*
   * children for WithPopover has to be a React.ReactElement and not React.ReactNode
   * React.ReactNode can be string or number, which cannot hold a ref
   */
  children: ReactElement
}

export const WithOrderItemTooltip = ({
  item,
  WithPopoverProps = {},
  disabled = false,
  children,
}: IWithOrderItemTooltipProps) => {
  const {
    placement = 'top',
    trigger = 'hover',
    ...otherWithPopoverProps
  } = WithPopoverProps

  return (
    <WithPopover
      content={
        <Card.Content>
          <OrderItemTooltip item={item} />
        </Card.Content>
      }
      placement={placement}
      trigger={trigger}
      disableHoverListener={disabled}
      {...otherWithPopoverProps}
    >
      {children}
    </WithPopover>
  )
}

WithOrderItemTooltip.displayName = 'WithOrderItemTooltip'
